import styled from 'styled-components'
import media from '../../../theme/media'

const DESKTOP_GAP = 1.25
const TABLET_GAP = 1
const MOBILE_GAP = 0.35

const FlexContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  margin: ${MOBILE_GAP * 2}rem -${MOBILE_GAP}rem;

  > span {
    flex: 1 0 50%;
    min-width: 15rem;
    width: 100%;
    margin-bottom: ${MOBILE_GAP * 2}rem;
  }
  
  ${media.tabletPortrait`
    margin: ${TABLET_GAP * 2}rem -${TABLET_GAP}rem;
    
    > span {
      margin-bottom: ${TABLET_GAP * 2}rem;
    }
  `}

  ${media.tablet`
    margin: ${DESKTOP_GAP * 2}rem -${DESKTOP_GAP}rem;
    
    > span {
      margin-bottom: ${DESKTOP_GAP * 2}rem;
    }
  `}
`

const FlexItem = styled.span`
  padding: 0 ${MOBILE_GAP}rem;

  ${media.tabletPortrait`
    padding: 0 ${TABLET_GAP}rem;
  `}

  ${media.tablet`
    padding: 0 ${DESKTOP_GAP}rem;
  `}
`

export { FlexContainer, FlexItem }
